import { WireDistributionState } from './types';

const state = (): WireDistributionState => {
  return {
    wireDistributions: [],
  };
};

export default state;
